import { render, staticRenderFns } from "./ImsInventoryCostModal.vue?vue&type=template&id=674f0282&"
import script from "./ImsInventoryCostModal.vue?vue&type=script&lang=js&"
export * from "./ImsInventoryCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports